import { AuthService } from '../services/auth.service';
import { Router } from '@angular/router';
import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { User } from '../User';

@Component({
  selector: 'app-navigation-top',
  templateUrl: './navigation-top.component.html',
  styleUrls: ['./navigation-top.component.css']
})
export class NavigationTopComponent implements OnInit {
  constructor(private router: Router, private authService: AuthService) {}

  user: User;
  role = '';
  showSidebarNav = false;
  @Output() sidebarToggled: EventEmitter<boolean> = new EventEmitter();

  ngOnInit() {
    this.user = this.authService.getUser();
    this.role = this.getRoleFromEntitlements();
  }

  getRoleFromEntitlements() {
    if (this.user.entitlements) {
      for (const ent of this.user.entitlements) {
        if (ent.substring(0, 5) === 'ROLE_') {
          const roleName = ent.substring(5);
          return roleName.replace(/_/g, ' ');
        }
      }
    }
    return '';
  }

  logout() {
    this.authService.logout();
    this.router.navigate(['/logout']);
  }

  public hideNavBar() {
    this.showSidebarNav = false;
  }

  toggleSidebar() {
    this.showSidebarNav = !this.showSidebarNav;
    this.sidebarToggled.emit(this.showSidebarNav);
  }
}
